import { useEffect, useRef } from 'react';
import useTakerMarkets from '@/enterprise/data/useTakerMarkets';
import { usePendingOfferPollingStore } from './usePendingOfferPollingStore';

const useHydratePendingOfferPolling = (): void => {
  const hasHydratedRef = useRef<boolean>(false);
  const { data: takerMarkets } = useTakerMarkets();
  const { addPendingMarkets } = usePendingOfferPollingStore();

  useEffect(() => {
    if (hasHydratedRef.current) {
      return;
    }

    hasHydratedRef.current = true;

    const pendingMarkets = (takerMarkets ?? []).filter((tm) => tm.offerStatsStatus === 'PENDING');

    if (pendingMarkets.length > 0) {
      addPendingMarkets(
        pendingMarkets.map((tm) => ({
          marketUuid: tm.marketUuid,
          takerDivisionUuid: tm.takerDivisionUuid,
          makerOrganizationUuid: tm.makerOrganizationUuid,
        }))
      );
    }
  }, [takerMarkets, addPendingMarkets]);
};

export default useHydratePendingOfferPolling;
